import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Destinations from './pages/Destinations';
import DestinationDetails from './pages/DestinationDetails';
import Packages from './pages/Packages';
import PackageDetails from './pages/PackageDetails';
import Contact from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/destinations" element={<Destinations data-id="element-10" />} data-id="element-9" />
            <Route path="/destinations/:id" element={<DestinationDetails data-id="element-12" />} data-id="element-11" />
            <Route path="/packages" element={<Packages data-id="element-14" />} data-id="element-13" />
            <Route path="/packages/:id" element={<PackageDetails data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
      </div>
    </Router>;
}